module.exports = __webpack_public_path__ + "static/media/WoT-blitz.57e0e20e.jpg";